export default __webpack_public_path__ + "src/images/packages/cradle-boutique-hotel/f4e53b49e816e0aa4fae95a0a0b526db-2.png";